var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import * as constant from '../../constant/common-type';
import moment from 'moment';
import eventBus from '../../utils/fresh-table';
import selfTextarea from '../../components/console-common/common-textarea.vue';
import { mapState } from 'vuex';
import { saveData } from '../../utils/storage';
import { checkName, checkInteger } from '../../utils/common-utils';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    created: function () {
        this.getUserName();
    },
    components: {
        'el-self-textarea': selfTextarea,
    },
    data: function () {
        var validatorNum = function (rule, value, callback) {
            if (value) {
                var reg = /^[0-9]{1,6}(\.[0-9]{1,2})?$/;
                if (!reg.test(value)) {
                    return callback(new Error('请输入数字，最多两位小数'));
                }
                else {
                    callback();
                }
            }
            else {
                callback();
            }
        };
        var isvalidatecontractTime = function (rule, value, callback) {
            if (value[0] == null ||
                value[0] == undefined ||
                value[1] == null ||
                value[1] == undefined) {
                return callback(new Error('请选择有效期'));
            }
            else {
                var date1 = value[0];
                var date2 = value[1];
                if (!date1.getTime) {
                    var dateArr = date1.split(' ')[0].split('-');
                    date1 = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
                }
                if (!date2.getTime) {
                    var dateArr = date2.split(' ')[0].split('-');
                    date2 = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
                }
                if (Date.parse(date1) > Date.parse(date2) ||
                    Date.parse(date1) === Date.parse(date2)) {
                    return callback(new Error('开始时间必须小于结束时间'));
                }
                else {
                    callback();
                }
            }
        };
        return {
            // ischangeCity: false,
            usernameZh: '',
            showData: {
                contractStatus: '',
                signStatus: '',
            },
            cityName: '',
            companyName: '',
            Isdisabled: true,
            add: true,
            // isDisabledLeaseMode: true,
            ruleForm: {
                contractCode: '',
                plateNumber: '',
                cityCode: '',
                // runMode: '',
                // cooperationMode: '',
                signStatus: '',
                contractDate: [],
                repayDate: [],
                leaseMode: '',
                signCompanyName: '',
                settlementCompanyName: '',
                totalDuration: 0,
                monthlyPayment: 0,
                totalAmount: 0,
                guaranteeDeposit: '',
                downPayment: '',
                tailPayment: '',
                transactorContract: '',
                transactorManager: '',
                transactorSale: '',
                note: '',
            },
            rules: {
                cityCode: [
                    { required: true, message: '请选择城市', trigger: 'change' },
                ],
                plateNumber: [
                    { required: true, message: '请输入车牌号', trigger: 'blur' },
                    {
                        pattern: /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5,6}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4,5})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
                        message: '车牌号格式不正确',
                        trigger: 'blur',
                    },
                ],
                contractDate: [
                    { required: true, message: '请选择合同有效期', trigger: 'change' },
                    {
                        required: true,
                        validator: isvalidatecontractTime,
                        trigger: 'change',
                    },
                ],
                repayDate: [
                    { required: true, message: '请选择还款有效期', trigger: 'change' },
                    {
                        required: true,
                        validator: isvalidatecontractTime,
                        trigger: 'change',
                    },
                ],
                totalDuration: [
                    { required: true, message: '请输入期数', trigger: 'blur' },
                    { validator: checkInteger, trigger: 'blur' },
                ],
                monthlyPayment: [
                    { required: true, message: '请输入月供', trigger: 'blur' },
                    { validator: validatorNum, trigger: 'blur' },
                ],
                guaranteeDeposit: [{ validator: validatorNum, trigger: 'blur' }],
                downPayment: [{ validator: validatorNum, trigger: 'blur' }],
                tailPayment: [{ validator: validatorNum, trigger: 'blur' }],
                totalAmount: [
                    {
                        required: true,
                        message: '请输入对应期数和月供/月租金',
                        trigger: 'blur',
                    },
                    { validator: validatorNum, trigger: 'blur' },
                ],
                transactorContract: [
                    { required: false, validator: checkName, trigger: 'blur' },
                ],
                transactorManager: [
                    { required: false, validator: checkName, trigger: 'blur' },
                ],
                transactorSale: [
                    { required: false, validator: checkName, trigger: 'blur' },
                ],
                signStatus: [
                    { required: true, message: '请选择协议状态', trigger: 'blur' },
                ],
            },
        };
    },
    computed: __assign({}, mapState(['contract', 'info']), { contractDetail: function () {
            return this.contract.contractDetail;
        },
        cityList: function () {
            return this.info.cityList;
        },
        signCompanyList: function () {
            return this.info.signCompanyList;
        },
        settleCompanyList: function () {
            return this.info.settleCompanyList;
        },
        IsDisabledEdit: function () {
            var _a = this.contractDetail, hasPlan = _a.hasPlan, signStatus = _a.signStatus;
            return hasPlan || signStatus === 'SIGNED';
        } }),
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        clearAmout: function () {
            this.ruleForm = Object.assign(this.ruleForm, {
                totalDuration: '',
                monthlyPayment: '',
                totalAmount: '',
                guaranteeDeposit: '',
                downPayment: '',
                tailPayment: '',
            });
        },
        getVehicleMsg: function () {
            var _this = this;
            var plateNumber = this.ruleForm.plateNumber;
            this.$refs['ruleForm'].validateField('plateNumber', function (errorMsg) {
                if (errorMsg !== '')
                    return false;
                _this.$request({
                    url: '/proxy/vehicle/driver/vehicle/briefInfo/plateNumber',
                    method: 'post',
                    data: {
                        creator: _this.usernameZh,
                        plateNumber: plateNumber,
                    },
                }).then(function (res) {
                    if (!res || res.errorCode) {
                        return;
                    }
                    var data = res.data;
                    if (!data || data.purpose === 'OTHER') {
                        _this.ruleForm = Object.assign(_this.ruleForm, {
                            leaseMode: 'JINGZU',
                        });
                        // this.isDisabledLeaseMode = false
                        return;
                    }
                    _this.ruleForm = Object.assign(_this.ruleForm, {
                        leaseMode: data.purpose,
                    });
                    // this.isDisabledLeaseMode = true
                });
            });
        },
        countTotal: function () {
            var _a = this.ruleForm, totalDuration = _a.totalDuration, monthlyPayment = _a.monthlyPayment;
            if (!isNaN(totalDuration) && !isNaN(monthlyPayment)) {
                return (this.ruleForm.totalAmount = this.$utils.toYuan(totalDuration * this.$utils.toFen(monthlyPayment)));
            }
            return (this.ruleForm.totalAmount = '0.00');
        },
        formatDate: function (time, formTime, index, flag) {
            if (this['ruleForm'][time] !== null &&
                this['ruleForm'][time] !== undefined) {
                this['ruleForm'][formTime] = moment(this['ruleForm'][time][index]).format('YYYY-MM-DD');
            }
            var contractTimeStart = this['ruleForm']['contractDate'][0];
            var contractTimeEnd = this['ruleForm']['contractDate'][1];
            var repaymentTimeStart = this['ruleForm']['repayDate'][0];
            if (contractTimeStart && !contractTimeStart.getTime) {
                var dateArr = contractTimeStart.split(' ')[0].split('-');
                contractTimeStart = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
            }
            if (contractTimeEnd && !contractTimeEnd.getTime) {
                var dateArr = contractTimeEnd.split(' ')[0].split('-');
                contractTimeEnd = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
            }
            if (repaymentTimeStart && !repaymentTimeStart.getTime) {
                var dateArr = repaymentTimeStart.split(' ')[0].split('-');
                repaymentTimeStart = new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
            }
            if (flag == 'auto') {
                if (contractTimeStart != null &&
                    contractTimeStart != undefined &&
                    (contractTimeEnd != null && contractTimeEnd != undefined) &&
                    (repaymentTimeStart != null && repaymentTimeStart != undefined)) {
                    var repaymentTimeEnd = new Date(contractTimeEnd.getTime() -
                        contractTimeStart.getTime() +
                        repaymentTimeStart.getTime());
                    if (this['ruleForm']['repayDate'].length > 1) {
                        this['ruleForm']['repayDate'].pop();
                    }
                    this['ruleForm']['repayDate'].push(repaymentTimeEnd);
                    this['ruleForm']['repayEndTime'] = moment(repaymentTimeEnd).format('YYYY-MM-DD');
                }
            }
        },
        save: function () {
            var _this = this;
            // 请求接口
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid)
                    return;
                var _a = _this.ruleForm, contractCode = _a.contractCode, plateNumber = _a.plateNumber, cityCode = _a.cityCode, leaseMode = _a.leaseMode, contractDate = _a.contractDate, repayDate = _a.repayDate, signStatus = _a.signStatus, signCompanyName = _a.signCompanyName, settlementCompanyName = _a.settlementCompanyName, totalDuration = _a.totalDuration, monthlyPayment = _a.monthlyPayment, totalAmount = _a.totalAmount, guaranteeDeposit = _a.guaranteeDeposit, downPayment = _a.downPayment, tailPayment = _a.tailPayment, 
                // runMode,
                // cooperationMode,
                transactorContract = _a.transactorContract, transactorManager = _a.transactorManager, transactorSale = _a.transactorSale, note = _a.note;
                var cityName = cityCode;
                _this.cityList.forEach(function (item) {
                    if (item.val === cityCode) {
                        cityName = item.label;
                    }
                });
                var params = {
                    contractCode: contractCode,
                    plateNumber: plateNumber,
                    cityName: cityName,
                    // runMode,
                    leaseMode: leaseMode,
                    signStatus: signStatus,
                    // cooperationMode,
                    startTime: moment(contractDate[0]).format('YYYY-MM-DD'),
                    endTime: moment(contractDate[1]).format('YYYY-MM-DD'),
                    repayStartTime: moment(repayDate[0]).format('YYYY-MM-DD'),
                    repayEndTime: moment(repayDate[1]).format('YYYY-MM-DD'),
                    signCompanyName: signCompanyName,
                    settlementCompanyName: settlementCompanyName,
                    totalDuration: totalDuration,
                    monthlyPayment: _this.$utils.toFen(monthlyPayment),
                    totalAmount: _this.$utils.toFen(totalAmount),
                    guaranteeDeposit: guaranteeDeposit
                        ? _this.$utils.toFen(guaranteeDeposit)
                        : '',
                    downPayment: downPayment ? _this.$utils.toFen(downPayment) : '',
                    transactorContract: transactorContract,
                    transactorManager: transactorManager,
                    transactorSale: transactorSale,
                    note: note,
                };
                _this.contractDetail.leaseMode === 'RONGZU' &&
                    (params = Object.assign(params, {
                        tailPayment: tailPayment ? _this.$utils.toFen(tailPayment) : '',
                    }));
                _this.$request({
                    method: 'post',
                    url: '/proxy/api/contract/edit',
                    data: __assign({}, params, { operator: _this.usernameZh }),
                }).then(function (res) {
                    if (!res)
                        return;
                    if (!res.errorCode) {
                        _this.$message({
                            message: '修改成功',
                            type: 'success',
                        });
                        _this.contract.isViewEditContractDialog = false;
                        eventBus.$emit('freshTable');
                    }
                });
            });
        },
        cancel: function () {
            this.contract.isViewEditContractDialog = false;
        },
        toContractAgreement: function () {
            var _a = this.contractDetail, tenantName = _a.tenantName, startTime = _a.startTime, endTime = _a.endTime, createTime = _a.createTime, driverName = _a.driverName, driverIdNo = _a.driverIdNo, totalAmount = _a.totalAmount, totalAmountUpperText = _a.totalAmountUpperText, contractCode = _a.contractCode, plateNumber = _a.plateNumber;
            saveData('agreement', {
                tenantName: tenantName,
                startTime: startTime,
                endTime: endTime,
                createTime: moment(createTime).format('YYYY-MM-DD'),
                driverName: driverName,
                driverIdNo: driverIdNo,
                totalAmount: this.$utils.toYuan(totalAmount),
                totalAmountUpperText: totalAmountUpperText,
                contractCode: contractCode,
                plateNumber: plateNumber,
            });
            var href = this.$router.resolve({
                name: 'contractAgreement',
            }).href;
            window.open(href, '_blank');
        },
        isEmpty: function (flag) {
            if (flag == 0) {
                this.cityHidden = this.cityName == '' ? 'inherit' : 'hidden';
                this.cityBorder = this.cityName == '' ? true : false;
            }
            else {
                this.comHidden = this.companyName == '' ? 'inherit' : 'hidden';
                this.comBorder = this.companyName == '' ? true : false;
            }
            this.Isdisabled = !(this.companyName != '' && this.cityName != '');
        },
        addCompany: function () {
            this.add = false;
        },
        cancelAdd: function () {
            this.cityHidden = 'hidden';
            this.comHidden = 'hidden';
            this.cityBorder = false;
            this.comBorder = false;
            this.Isdisabled = true;
            this.add = true;
            this.companyName = '';
            this.cityName = '';
        },
        sureAdd: function (type) {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/company/add',
                data: {
                    type: type,
                    name: this.companyName,
                    creator: this.usernameZh,
                    // tenant:this.merchantId,
                    cityName: this.cityName,
                },
            }).then(function (res) {
                if (!res) {
                    _this.add = true;
                    _this.companyName = '';
                    _this.cityName = '';
                    return;
                }
                if (!res.errorCode) {
                    _this.$store.dispatch('info/GET_COMPANY_ALL', { type: type });
                    _this.add = true;
                    _this.companyName = '';
                    _this.cityName = '';
                }
            });
        },
    },
    watch: {
        contractDetail: function (val) {
            var contractCode = val.contractCode, cityName = val.cityName, activeState = val.activeState, leaseMode = val.leaseMode, signStatus = val.signStatus, plateNumber = val.plateNumber, startTime = val.startTime, endTime = val.endTime, repayStartTime = val.repayStartTime, repayEndTime = val.repayEndTime, totalDuration = val.totalDuration, monthlyPayment = val.monthlyPayment, totalAmount = val.totalAmount, guaranteeDeposit = val.guaranteeDeposit, downPayment = val.downPayment, tailPayment = val.tailPayment, 
            // runMode,
            // cooperationMode,
            transactorContract = val.transactorContract, transactorManager = val.transactorManager, transactorSale = val.transactorSale, note = val.note, signCompanyName = val.signCompanyName, settlementCompanyName = val.settlementCompanyName;
            this.ruleForm = Object.assign(this.ruleForm, {
                contractCode: contractCode,
                cityCode: cityName,
                plateNumber: plateNumber,
                leaseMode: leaseMode,
                signStatus: signStatus,
                contractDate: [startTime, endTime],
                repayDate: [repayStartTime, repayEndTime],
                signCompanyName: signCompanyName,
                settlementCompanyName: settlementCompanyName,
                totalDuration: totalDuration,
                monthlyPayment: this.$utils.toYuan(monthlyPayment),
                totalAmount: this.$utils.toYuan(totalAmount),
                guaranteeDeposit: guaranteeDeposit
                    ? this.$utils.toYuan(guaranteeDeposit)
                    : '',
                downPayment: downPayment ? this.$utils.toYuan(downPayment) : '',
                tailPayment: tailPayment ? this.$utils.toYuan(tailPayment) : '',
                // runMode,
                transactorContract: transactorContract,
                transactorManager: transactorManager,
                transactorSale: transactorSale,
                // cooperationMode,
                note: note,
            });
            this.showData = Object.assign(this.showData, {
                contractStatus: constant.contractBoardName[activeState],
                signStatus: constant.signStatus[signStatus],
            });
            // this.isDisabledLeaseMode = true
            this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SIGN' });
            this.$store.dispatch('info/GET_COMPANY_ALL', { type: 'SETTLEMENT' });
        },
    },
});
